import IRangeConfig from './RangeConfig';
import Ranges from '../Range/Ranges';
import Range from '../Range';
import DecimalPrecisionError from '../../../Errors/DecimalPrecisionError';
import InvalidInputError from '../../../Errors/InvalidInputError';
import MalformedRangeError from '../../../Errors/MalformedRangeError';

export default class RangeConverter {
  /**
   * Static method to create Object(type : Ranges) with collection of objects(type:Range) from
   * ranges list input
   * @return Ranges
   * @throws DecimalPrecisionError
   *    - if any of the values for minimum, maximum or increment has a decimal precision greater than 8.
   * @throws MalformedRangeError
   *    - if any of the the values for minimum, maximum or increment are invalid.
   * @throws InvalidInputError
   *    - if the input is an empty collection or cannot be converted to Ranges type for any other reasons.
   */
  static toRanges(rangesConfig : IRangeConfig[]) {
    const ranges : Range[] = [];
    try {
      rangesConfig.forEach((rangeConfig) => {
        ranges.push(RangeConverter.toRange(rangeConfig));
      });
    } catch (er) {
      if (er instanceof InvalidInputError || er instanceof DecimalPrecisionError || er instanceof MalformedRangeError) {
        throw er;
      }
      throw new InvalidInputError('The input cannot be converted to Ranges');
    }
    return new Ranges(ranges);
  }

  /**
   * Static method to create Object(type : Range) from range input
   * @return Range
   * @throws DecimalPrecisionError
   *    - if any of the values for minimum, maximum or increment has a decimal precision greater than 8.
   * @throws MalformedRangeError
   *    - if any of the the values for minimum, maximum or increment are invalid.
   */
  static toRange(rangeConfig : IRangeConfig) : Range {
    return new Range(rangeConfig.minimum, rangeConfig.maximum, rangeConfig.increment);
  }
}
